import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-permission-button',
  templateUrl: './permission-button.component.html',
  styleUrls: ['./permission-button.component.css'],
})
export class PermissionButtonComponent {
  @Input() text!: string
  @Input() permissionTickets!: any[]


  @Output() click = new EventEmitter<any>()


  executeFx() {
    this.click.emit(true);
  }

  hasNotification(ticketList?: any[]): boolean {
    if (Array.isArray(ticketList) && ticketList.length > 0) {
      return ticketList.some((ticket) => ticket.statusPermission === 0);
    }
    return false;
  }
}
